class AccordionController {
    constructor() {
      this.accordions = document.querySelectorAll('[data-accordion]');
      this.activeClass = 'active';
      this.transitionDuration = 300; // ms
      this.setup();
    }
  
    setup() {
      this.accordions.forEach((accordion, index) => {
        const trigger = accordion.querySelector('[data-accordion-trigger]');
        if (trigger) {
          trigger.addEventListener('click', (e) => this.handleClick(e));
        }
        // Open first accordion by default
        if (index === 0) {
          this.open(accordion);
        }
      });
    }
  
    handleClick(event) {
      const trigger = event.currentTarget;
      const accordion = trigger.closest('[data-accordion]');
      
      if (accordion) {
        const isOpen = accordion.classList.contains(this.activeClass);
        
        // Close other accordions
        this.closeAll(accordion);
        
        // Toggle current accordion
        if (isOpen) {
          this.close(accordion);
        } else {
          this.open(accordion);
        }
      }
    }
  
    open(accordion) {
      const content = accordion.querySelector('[data-accordion-content]');
      if (!content) return;
  
      accordion.classList.add(this.activeClass);
      
      // Set initial height for transition
      const height = content.scrollHeight;
      content.style.maxHeight = height + 'px';
      content.style.opacity = '1';
      content.style.padding = '16px';
      
      // Update icon - Change from + to -
      const icon = accordion.querySelector('.accordion-icon');
      if (icon) {
        icon.textContent = '−'; // Using minus sign (U+2212)
      }
    }
  
    close(accordion) {
      const content = accordion.querySelector('[data-accordion-content]');
      if (!content) return;
  
      accordion.classList.remove(this.activeClass);
      content.style.maxHeight = '0';
      content.style.opacity = '0';
      content.style.padding = '0';
      
      // Update icon - Change from - to +
      const icon = accordion.querySelector('.accordion-icon');
      if (icon) {
        icon.textContent = '+';
      }
    }
  
    closeAll(exceptAccordion = null) {
      this.accordions.forEach(accordion => {
        if (accordion !== exceptAccordion) {
          this.close(accordion);
        }
      });
    }
  
    // Public method to reinitialize accordions (useful for dynamic content)
    reinitialize() {
      this.accordions = document.querySelectorAll('[data-accordion]');
      this.setup();
    }
  
    // Public method to open specific accordion by index
    openByIndex(index) {
      if (this.accordions[index]) {
        this.closeAll(this.accordions[index]);
        this.open(this.accordions[index]);
      }
    }
  
    // Public method to open accordion by id
    openById(id) {
      const accordion = document.querySelector(`[data-accordion="${id}"]`);
      if (accordion) {
        this.closeAll(accordion);
        this.open(accordion);
      }
    }
  }
  
  // Initialize accordion functionality
  document.addEventListener('DOMContentLoaded', () => {
    window.accordionController = new AccordionController();
  });
  
  // Handle Shopify section events
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('[data-accordion]')) {
      window.accordionController?.reinitialize();
    }
  });
  
  // Optional: Handle dynamic content updates
  document.addEventListener('accordions:updated', () => {
    window.accordionController?.reinitialize();
  });